// Skema per divisi untuk ServiceWorkspacePanel.
// Setiap divisi punya: kind, division_id, label, briefFields[], checklistKeys[], stages[],
// showHandovers, handoverLabels, showAppointments, appointmentLabel

export const SW_SCHEMAS = {
  mua: {
    kind: "mua", division_id: "div-mua", label: "MUA",
    briefFields: [
      { key: "style", label: "Style / Look", placeholder: "Natural glam, bold, korea style..." },
      { key: "skin_tone", label: "Warna Kulit", placeholder: "Fair / medium / tan" },
      { key: "allergies", label: "Alergi / Sensitivitas", placeholder: "Latex, parfum, dsb.", textarea: true },
      { key: "reference_urls", label: "Referensi Foto (URL, pisahkan spasi)", textarea: true, isList: true },
      { key: "hair_style", label: "Hair Style", placeholder: "Sanggul, wavy, updo..." },
      { key: "special_request", label: "Permintaan Khusus", textarea: true },
    ],
    checklistKeys: [
      { key: "kit_list", label: "Kit List (bawaan)" },
      { key: "pre_prep", label: "Pre-Prep (H-1)" },
    ],
    stages: ["Prep", "Trial", "Wedding Day", "Serah Terima"],
    showHandovers: true, handoverLabels: { out: "Kit keluar", "in": "Kit masuk", return: "Kembali" },
    showAppointments: true, appointmentLabel: "Jadwal (Trial / Wedding Day)",
  },
  decor: {
    kind: "decor", division_id: "div-decor", label: "Dekor",
    briefFields: [
      { key: "theme", label: "Tema / Konsep", placeholder: "Rustic garden, modern minimalist..." },
      { key: "color_palette", label: "Palet Warna", placeholder: "Dusty pink, sage, white" },
      { key: "layout_url", label: "URL Denah / Layout" },
      { key: "special_items", label: "Item Khusus", textarea: true },
      { key: "flower_types", label: "Jenis Bunga", placeholder: "Baby breath, hydrangea..." },
    ],
    checklistKeys: [
      { key: "bring", label: "Barang Dibawa (bring)" },
      { key: "return", label: "Barang Dikembalikan (return)" },
      { key: "setup_steps", label: "Progres Pemasangan" },
      { key: "teardown", label: "Bongkar (post-event)" },
    ],
    stages: ["Persiapan", "Loading", "Setup Venue", "Serah Terima", "Bongkar", "Pengembalian"],
    showHandovers: true, handoverLabels: { out: "Loading keluar", "in": "Setup selesai", return: "Return gudang" },
    showAppointments: true, appointmentLabel: "Jadwal Loading & Bongkar",
  },
  pbh: {
    kind: "pbh", division_id: "div-photo", label: "PBH (Foto & Video)",
    briefFields: [
      { key: "package_scope", label: "Cakupan Paket", textarea: true, placeholder: "Preweding, akad, resepsi..." },
      { key: "deliverables", label: "Deliverable", textarea: true, placeholder: "Album 20x30, 500 foto edit, 3 menit video..." },
      { key: "style_reference", label: "Referensi Style (URL)", isList: true, textarea: true },
      { key: "moments_wajib", label: "Momen Wajib Ekstra", textarea: true },
      { key: "album_spec", label: "Spesifikasi Album", placeholder: "20x30 hardcover 30 halaman" },
    ],
    checklistKeys: [
      { key: "shot_list", label: "Shot List" },
      { key: "backup_confirm", label: "Konfirmasi Backup" },
      { key: "editing_progress", label: "Progres Editing" },
      { key: "revision", label: "Revisi" },
      { key: "album_progress", label: "Album" },
    ],
    stages: ["Shooting", "Backup", "Editing", "Client Preview", "Revisi", "Album", "Delivery", "Completed"],
    showHandovers: true, handoverLabels: { out: "Serah file draft", "in": "Serah file final", return: "Album serah" },
    showAppointments: true, appointmentLabel: "Jadwal Shooting & Preview",
  },
  snap: {
    kind: "snap", division_id: "div-snap", label: "Historia Snap",
    briefFields: [
      { key: "package", label: "Paket Snap", placeholder: "1 sesi 30 menit, 50 foto" },
      { key: "style_pref", label: "Style", placeholder: "Candid, natural, journalistic" },
      { key: "reference_urls", label: "Referensi (URL)", isList: true, textarea: true },
      { key: "must_capture", label: "Momen Wajib", textarea: true },
      { key: "delivery_target", label: "Target Delivery", placeholder: "H+2 hari" },
    ],
    checklistKeys: [
      { key: "moments", label: "Momen Wajib" },
      { key: "quick_prod", label: "Produksi Cepat" },
      { key: "review", label: "Review Internal" },
    ],
    stages: ["Shooting", "Sortir", "Editing Cepat", "Review", "Delivery"],
    showHandovers: true, handoverLabels: { out: "Kirim draft", "in": "Kirim final", return: "-" },
    showAppointments: true, appointmentLabel: "Jadwal Sesi",
  },
  wo: {
    kind: "wo", division_id: "div-wo", label: "Wedding Organizer",
    briefFields: [
      { key: "guest_count", label: "Jumlah Tamu" },
      { key: "flow_summary", label: "Ringkasan Alur", textarea: true, placeholder: "08.00 rias, 10.00 akad, 12.00 resepsi..." },
      { key: "vendors_involved", label: "Vendor Terlibat", textarea: true },
      { key: "critical_notes", label: "Catatan Kritis", textarea: true },
    ],
    checklistKeys: [
      { key: "rundown", label: "Rundown Detail" },
      { key: "positions", label: "Posisi / PIC" },
      { key: "h_minus_1", label: "Kesiapan H-1" },
      { key: "issues", label: "Log Kendala" },
      { key: "post_evaluation", label: "Evaluasi Pasca Acara" },
    ],
    stages: ["Planning", "H-7", "H-1", "Hari-H", "Selesai", "Evaluasi"],
    showHandovers: false,
    showAppointments: true, appointmentLabel: "Rapat & Milestone",
  },
  music: {
    kind: "music", division_id: "div-music", label: "Musical",
    briefFields: [
      { key: "genre", label: "Genre / Style", placeholder: "Acoustic, orkestra, band lengkap" },
      { key: "song_requests", label: "Song Request", textarea: true },
      { key: "band_size", label: "Ukuran Personel" },
      { key: "special_arrangement", label: "Aransemen Khusus", textarea: true },
    ],
    checklistKeys: [
      { key: "rehearsal", label: "Jadwal Latihan" },
      { key: "soundcheck", label: "Soundcheck" },
      { key: "setlist", label: "Setlist (urut)" },
      { key: "cue_sheet", label: "Cue Sheet" },
      { key: "personel", label: "Personel & Peran" },
      { key: "equipment", label: "Checklist Alat" },
    ],
    stages: ["Persiapan", "Latihan", "Soundcheck", "Perform", "Selesai"],
    showHandovers: false,
    showAppointments: true, appointmentLabel: "Latihan & Soundcheck",
  },
  attire: {
    kind: "attire", division_id: "div-attire", label: "Historia Attire",
    briefFields: [
      { key: "attire_type", label: "Jenis Busana", placeholder: "Gaun akad, kebaya resepsi, jas..." },
      { key: "size", label: "Ukuran / Body Measurement", textarea: true },
      { key: "style_ref", label: "Referensi Style (URL)", isList: true, textarea: true },
      { key: "accessories", label: "Aksesoris", textarea: true },
    ],
    checklistKeys: [
      { key: "fitting", label: "Fitting Appointment" },
      { key: "adjustment", label: "Penyesuaian (jahit/aksesori)" },
      { key: "condition_out", label: "Kondisi Keluar" },
      { key: "condition_in", label: "Kondisi Masuk" },
      { key: "care_log", label: "Log Perawatan" },
    ],
    stages: ["Reservasi", "Fitting", "Penyesuaian", "Keluar", "Kembali", "Perawatan"],
    showHandovers: true, handoverLabels: { out: "Busana keluar", "in": "Busana kembali", return: "Selesai perawatan" },
    showAppointments: true, appointmentLabel: "Fitting & Pengembalian",
  },
  handcraft: {
    kind: "handcraft", division_id: "div-handcraft", label: "Historia Handcraft",
    briefFields: [
      { key: "product_type", label: "Jenis Produk", placeholder: "Souvenir, mahar, seserahan..." },
      { key: "spec", label: "Spesifikasi", textarea: true },
      { key: "quantity", label: "Kuantitas" },
      { key: "design_ref", label: "Referensi Desain (URL)", isList: true, textarea: true },
      { key: "mockup_url", label: "URL Mockup Desain" },
      { key: "design_approved", label: "Status Persetujuan Desain", placeholder: "Belum / Approved / Revisi" },
    ],
    checklistKeys: [
      { key: "materials", label: "Bahan (BoM)" },
      { key: "production", label: "Produksi" },
      { key: "qc", label: "Quality Control" },
    ],
    stages: ["Order", "Desain", "Approved", "Produksi", "QC", "Penyerahan"],
    showHandovers: true, handoverLabels: { out: "Serah hasil", "in": "-", return: "-" },
    showAppointments: false,
  },
  warawiri: {
    kind: "warawiri", division_id: "div-warawiri", label: "Wara Wiri Entertainment",
    briefFields: [
      { key: "acts", label: "Jenis Acts", placeholder: "MC, Dangdut, DJ, Dancer, Sinden..." },
      { key: "host_names", label: "MC / Host", placeholder: "Nama MC utama & pendamping" },
      { key: "song_requests", label: "Song Request", textarea: true },
      { key: "duration", label: "Durasi Show", placeholder: "3 sesi × 30 menit" },
      { key: "band_size", label: "Ukuran Personel" },
      { key: "special_arrangement", label: "Arahan Khusus", textarea: true },
    ],
    checklistKeys: [
      { key: "rehearsal", label: "Latihan" },
      { key: "soundcheck", label: "Soundcheck" },
      { key: "setlist", label: "Setlist / Rundown Acts" },
      { key: "personel", label: "Personel & Peran" },
      { key: "equipment", label: "Checklist Alat" },
    ],
    stages: ["Persiapan", "Latihan", "Soundcheck", "Perform", "Selesai"],
    showHandovers: false,
    showAppointments: true, appointmentLabel: "Latihan & Soundcheck",
  },
  effect: {
    kind: "effect", division_id: "div-effect", label: "Wedding Effect",
    briefFields: [
      { key: "effect_types", label: "Jenis Efek", placeholder: "Cold spark, dry ice, confetti, CO2, smoke, bubble" },
      { key: "cue_moments", label: "Momen Cue", textarea: true, placeholder: "Prosesi masuk, cake cutting, first dance..." },
      { key: "safety_notes", label: "Catatan Keselamatan", textarea: true },
      { key: "power_source", label: "Sumber Listrik / Genset" },
      { key: "venue_permission", label: "Izin Venue", placeholder: "Sudah / Belum / Pending" },
      { key: "coverage_area", label: "Area / Titik Efek", textarea: true },
    ],
    checklistKeys: [
      { key: "equipment", label: "Peralatan & Refill" },
      { key: "cue_sheet", label: "Cue Sheet Detail" },
      { key: "safety_check", label: "Safety Check (APAR, jarak, ventilasi)" },
      { key: "load_in", label: "Loading & Setup" },
      { key: "teardown", label: "Bongkar" },
    ],
    stages: ["Persiapan", "Loading", "Setup", "Cue Live", "Bongkar"],
    showHandovers: true, handoverLabels: { out: "Load-in", "in": "Setup selesai", return: "Return gudang" },
    showAppointments: true, appointmentLabel: "Loading & Cue Time",
  },
  adat: {
    kind: "adat", division_id: "div-adat", label: "Upacara Adat",
    briefFields: [
      { key: "adat_type", label: "Jenis Adat", placeholder: "Jawa, Sunda, Batak, Minang, Bali, Bugis..." },
      { key: "prosesi_list", label: "Rangkaian Prosesi", textarea: true, placeholder: "Siraman, midodareni, panggih, sungkeman..." },
      { key: "pemangku_adat", label: "Pemangku Adat / Sesepuh", textarea: true },
      { key: "sesaji_items", label: "Sesaji / Perlengkapan Adat", textarea: true },
      { key: "narrator", label: "MC / Narator Adat" },
      { key: "special_notes", label: "Catatan Khusus Keluarga", textarea: true },
    ],
    checklistKeys: [
      { key: "perlengkapan", label: "Perlengkapan Adat" },
      { key: "narahubung", label: "Narahubung Keluarga" },
      { key: "rundown_adat", label: "Rundown Prosesi" },
      { key: "brief_pengantin", label: "Brief Pengantin & Keluarga" },
      { key: "post_event", label: "Setelah Prosesi" },
    ],
    stages: ["Persiapan", "H-1 Briefing", "Prosesi", "Selesai"],
    showHandovers: false,
    showAppointments: true, appointmentLabel: "Briefing & Prosesi",
  },
};

export const SW_KIND_BY_DIVISION = Object.fromEntries(
  Object.values(SW_SCHEMAS).map((s) => [s.division_id, s.kind])
);
